import {Form, Input, message, Modal, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {errorMessage} from 'Utils/common';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import SelectDict from 'Features/Select/SelectDict';
import {editLocate, LocateEntityItem} from '../../service';
import {useDict} from '../../../../../../store';

interface Props extends ModalProps {
    data?: LocateEntityItem;
    catid: string;
    parentId: number;
    onOk: () => void;
}

const Index = ({data, catid, parentId, onOk, ...props}: Props) => {
    const dict = useDict();
    const [form] = Form.useForm<LocateEntityItem>();
    const [save, {loading: saveLoading}] = useRequestFn(editLocate);

    async function onFinish(formData: LocateEntityItem) {
        try {
            if (data) {
                formData.id = data.id;
            }
            formData.catid = catid;
            formData.parentId = parentId;
            await save(formData);
            message.success('编辑成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            width={800}
            title="编辑定位"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    labelCol={{span: 6}}
                    initialValues={data}>
                    <Form.Item
                        name="positionName"
                        label="定位名称"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="positionType"
                        label="定位类型"
                        initialValue={dict.PositionType.firstValue}
                        rules={[{required: true}]}>
                        <SelectDict options={dict.PositionType.data} />
                    </Form.Item>
                    <Form.Item
                        name="positionXpath"
                        label="定位Xpath"
                        help="positionXpath"
                        rules={[{required: true}]}>
                        <Input.TextArea placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="valuePosition"
                        label="text和其他属性"
                        help="valuePosition"
                        rules={[{required: parentId !== 0}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
